/**
 * PlanningEventGroupEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionEntity } from "../RegionEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { PlanningEventDependencyEntity } from "../PlanningEventDependencyEntity";
import { PlanningEventGroupEntity } from "../PlanningEventGroupEntity";
declare global {
    interface EntityTypeMap {
        PlanningEventGroup: PlanningEventGroupEntity;
    }
}
export abstract class PlanningEventGroupGeneratedEntity extends BaseEntity {
    public abstract planningEventGroupId: string;
    public abstract templateId: string | null;
    public abstract creationDate: Date;
    public abstract text: string | null;
    public abstract project: ProjectEntity;
    public abstract region: RegionEntity | null;
    public abstract readonly planningEvents: ReadonlyArray<PlanningEventEntity>;
    public abstract readonly successorDependencies: ReadonlyArray<PlanningEventDependencyEntity>;
    public abstract readonly predecessorDependencies: ReadonlyArray<PlanningEventDependencyEntity>;
}
